import {
  DialogTitle,
  Divider,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { CardRow, EditableCardRow } from "../../../components/common";
import { useContractContext } from "../../../contexts/ContractContext";

import { useOrganizationContext } from "../../../contexts/OrganizationContext";

import dayjs from "dayjs";
import { useState } from "react";
import { DetailsPlanDialog } from "./DetailsPlanDialog";
import { CancelPlanDialog } from "./CancelPlanDialog";
import { endpoints } from "../../../configs/Settings";
import { useSessionContext } from "../../../contexts/SessionContext";
import { CommonDialog } from "../../../components/common/CommonDialog";
import { InfoMessage } from "../../TermsOfUse/components/BackupNotice";
import { ExtensionsDetails } from "./ExtensionsDetails";
import { useFluxPayContractContext } from "@/contexts/FluxPayContractContext";
import { useDiscussionCaseContext } from "@/contexts/DiscussionCaseContext";
import { useMedicalReportsAgentContext } from "@/contexts/MedicalReportsAgentContext";
import { useGuidanceAgentContext } from "@/contexts/GuidanceAgentContext";
import { useSecretaryAgentContext } from "@/contexts/SecretaryAgentContext";
import { usePostAttendanceContext } from "@/contexts/PostAttendanceContext";
import {
  getNextPaymentDueDate,
  isFluxPayContract as isFluxPayContractUtil,
  isFreePlanContract,
} from "@/utils/contract";

export function CardSubscription() {
  const { user } = useSessionContext();
  const { currentContract } = useContractContext();
  const { organization, typeOrganization } = useOrganizationContext();
  const [openEditPlan, setOpenEditPlan] = useState<boolean>(false);
  const [modalInformation, setModalInformation] = useState<boolean>(false);

  // Extensions
  const { contractFluxPay } = useFluxPayContractContext();
  const { contractDiscussionCase } = useDiscussionCaseContext();
  const { contractMedicalReports } = useMedicalReportsAgentContext();
  const { contractGuidance } = useGuidanceAgentContext();
  const { contractSecretaryAgent } = useSecretaryAgentContext();
  const { contractPostAttendance } = usePostAttendanceContext();

  const [openDetailsContract, setOpenDetailsContract] = useState<boolean>();
  const [openDetailsExtensions, setOpenDetailsExtensions] = useState<boolean>();

  const resource = currentContract?.[0]?.resource;

  console.log('currentContract', currentContract)

  const fiscalVerify = true;
  // organization?.extension
  //   ?.find((ext: any) =>
  //     ext?.url?.includes("StructureDefinition/OrganizationManager")
  //   )
  //   ?.extension?.find((i: any) => i?.url === "id")?.valueIdentifier?.value ===
  // user?.username;

  // Plano gratuito: contrato sem próxima cobrança e com upgrade disponível.
  const isFreePlan = isFreePlanContract(resource);

  const currentPlan = isFreePlan
    ? "Plano gratuito"
    : resource?.term?.[0].text || "-";
  const financialResponsible =
    organization?.extension?.find((el) =>
      el.url?.includes("OrganizationManager"),
    )?.extension?.[1]?.valueString || "-";
  // Busca a extensão subscriptionType se existir
  const subscriptionTypeExtension = resource?.extension?.find((el) =>
    el?.url.includes("subscriptionType"),
  )?.valueString;

  // Verifica se é um contrato de período grátis:
  // Tipo "bus" E subscriptionType contém "Profissional autônomo - Período grátis"
  // Esse tipo de contrato tem 30 dias de validade a partir da data de emissão
  const isFreeTrialContract =
    typeOrganization === "bus" &&
    subscriptionTypeExtension?.includes(
      "Profissional autônomo - Período grátis",
    );

  const nextPaymentDueDate = getNextPaymentDueDate(resource);

  // Verifica se o contrato é do tipo fluxPay
  const isFluxPayContract = isFluxPayContractUtil(resource);

  // Verifica se é tipo "bus" sem extensão nextPaymentDueDate (exceto fluxPay e período grátis)
  // Com fluxPay, mesmo sem nextPaymentDate está ativo, então não considera como bus sem pagamento
  const isBusWithoutNextPayment =
    typeOrganization === "bus" &&
    !nextPaymentDueDate &&
    !isFluxPayContract &&
    !isFreeTrialContract;

  // Calcula a data formatada para exibição:
  // - Se for período grátis: usa issued + 30 dias
  // - Se houver nextPaymentDueDate: usa a extensão
  // - Caso contrário: "-"
  const contractIssuedDate = dayjs(resource?.term?.[0]?.issued);
  const formattedDate = (() => {
    if (isFreeTrialContract && contractIssuedDate.isValid()) {
      return contractIssuedDate.add(30, "day").format("DD/MM/YYYY");
    }
    if (nextPaymentDueDate) {
      return dayjs(nextPaymentDueDate).format("DD/MM/YYYY");
    }
    return "-";
  })();

  // Para período grátis: calcula dias desde a emissão e dias restantes
  const daysSinceIssued =
    isFreeTrialContract && contractIssuedDate.isValid()
      ? dayjs().diff(contractIssuedDate, "day")
      : null;

  const freeTrialEndDate =
    isFreeTrialContract && contractIssuedDate.isValid()
      ? contractIssuedDate.add(30, "day")
      : null;

  const daysRemaining =
    freeTrialEndDate && freeTrialEndDate.isValid()
      ? freeTrialEndDate.diff(dayjs(), "day")
      : null;

  // Verifica se já passaram os 30 dias do período grátis
  const hasPassed30Days =
    isFreeTrialContract && daysSinceIssued !== null && daysSinceIssued >= 30;

  const hasExtensions =
    contractFluxPay ||
    contractDiscussionCase ||
    contractMedicalReports ||
    contractGuidance ||
    contractSecretaryAgent ||
    contractPostAttendance;

  return (
    <Stack
      id="signature"
      sx={{
        border: "1px solid",
        borderColor: "neutral700.main",
        borderRadius: "15px",
      }}
      width="100%"
      paddingTop={2}
    >
      <Typography
        variant="h5"
        fontWeight="500"
        paddingBottom={3}
        paddingLeft={5}
      >
        Assinaturas
      </Typography>
      <EditableCardRow
        title="Plano atual"
        type="details"
        titleContext={currentPlan}
        onClick={() => setOpenDetailsContract(true)}
      />
      <EditableCardRow
        title="Fluxmed Extensions"
        type="details"
        titleContext={
          hasExtensions
            ? `A clínica tem extensões ativas`
            : "A clínica não tem extensões ativas"
        }
        onClick={() => setOpenDetailsExtensions(true)}
      />
      <Divider sx={{ marginLeft: 5 }} />
      <CardRow
        title="Responsável financeiro"
        titleContext={financialResponsible}
      />
      <Divider sx={{ marginLeft: 5 }} />
      {/* Período grátis: mostra dias restantes e opção de realizar nova assinatura, ou renovar após 30 dias */}
      {isFreePlan ? (
        <EditableCardRow
          title="Próximo pagamento"
          auxText="Fazer upgrade"
          onClick={() => {
            localStorage.setItem("operation", "renewPlan");
            localStorage.setItem("organizationValue", `${organization?.id}`);
            window.location.replace(`${endpoints.REGISTER}`);
          }}
          titleContext="-"
        />
      ) : isFreeTrialContract ? (
        <>
          {hasPassed30Days ? (
            // Após 30 dias: mostra opção para renovar assinatura
            <EditableCardRow
              title="Próximo pagamento"
              auxText="Renovar Assinatura"
              onClick={() => {
                localStorage.setItem("operation", "renewPlan");
                localStorage.setItem(
                  "organizationValue",
                  `${organization?.id}`,
                );
                window.location.replace(`${endpoints.REGISTER}`);
              }}
              titleContext="Período grátis concluído"
            />
          ) : (
            // Durante período grátis: mostra dias restantes e opção de realizar nova assinatura
            <EditableCardRow
              title="Próximo pagamento"
              auxText="Realizar nova assinatura"
              onClick={() => {
                localStorage.setItem("operation", "renewPlan");
                localStorage.setItem(
                  "organizationValue",
                  `${organization?.id}`,
                );
                window.location.replace(`${endpoints.REGISTER}`);
              }}
              titleContext={
                daysRemaining !== null && daysRemaining > 0
                  ? `Período grátis - ${daysRemaining} ${
                      daysRemaining === 1 ? "dia restante" : "dias restantes"
                    }`
                  : "Período grátis ativo"
              }
            />
          )}
        </>
      ) : currentContract?.length &&
        ((!isBusWithoutNextPayment && !isFreeTrialContract) ||
          isFluxPayContract) ? (
        // Contratos normais: mostra opção de cancelar
        <>
          {fiscalVerify ? (
            <EditableCardRow
              title="Próximo pagamento"
              auxText="Cancelar assinatura"
              colorButton="error700.main"
              onClick={() => setOpenEditPlan(!openEditPlan)}
              titleContext={formattedDate}
            />
          ) : (
            <Tooltip title="Somente o responsável financeiro pode cancelar assinatura">
              <EditableCardRow
                title="Próximo pagamento"
                auxText="Cancelar assinatura"
                colorButton="error700.main"
                onClick={() => setModalInformation(true)}
                titleContext={formattedDate}
              />
            </Tooltip>
          )}
        </>
      ) : (
        // Outros casos: mostra opção de realizar/renovar assinatura
        <EditableCardRow
          title="Próximo pagamento"
          auxText={
            isBusWithoutNextPayment
              ? "Realizar Assinatura"
              : "Renovar Assinatura"
          }
          onClick={() => {
            localStorage.setItem("operation", "renewPlan");
            localStorage.setItem("organizationValue", `${organization?.id}`);
            window.location.replace(`${endpoints.REGISTER}`);
          }}
          titleContext={formattedDate}
        />
      )}

      <Divider sx={{ marginLeft: 5 }} />
      {openDetailsContract && (
        <DetailsPlanDialog
          open={openDetailsContract}
          handleClose={() => setOpenDetailsContract(false)}
        />
      )}
      {openEditPlan && (
        <CancelPlanDialog open={openEditPlan} setOpen={setOpenEditPlan} />
      )}
      {modalInformation && (
        <CommonDialog
          isOpen={modalInformation}
          handleClose={() => setModalInformation(false)}
        >
          <DialogTitle textAlign="center">Responsável financeiro</DialogTitle>
          <Stack alignItems="center" spacing={2} mt={2} mb={2} p={1}>
            <InfoMessage
              message={`${financialResponsible} é o responsável pelo plano de assinatura`}
            />
            <InfoMessage message="Somente o responsável financeiro pode cancelar a assinatura" />
          </Stack>
        </CommonDialog>
      )}

      {openDetailsExtensions && (
        <ExtensionsDetails
          isOpen={openDetailsExtensions}
          handleClose={() => setOpenDetailsExtensions(false)}
        />
      )}
    </Stack>
  );
}
